import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Alert, CfpTranslateModule, CurrencyModule, Icon, Link, ModalContent, Paging, PagingLimit } from '@cfp/ui';
import { BuildingChangeLogItemDTO, BuildingDetailsDTO, BuildingSystemChangeLogItemDTO } from 'csr-asset-app';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { Subject } from 'rxjs';
import { AuditTrailItem } from './audit-trail-item';

@Component({
  templateUrl: 'audit-trail-modal.html',
  styleUrls: ['audit-trail-modal.scss'],
  animations: [
    trigger('slideLeftRight', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))])
    ])
  ],
  imports: [
    AuditTrailItem,
    ModalContent,
    Icon,
    Link,
    PaginationModule,
    Paging,
    PagingLimit,
    NgClass,
    CfpTranslateModule,
    Alert,
    CurrencyModule
  ]
})
export class AuditTrailModal {
  private readonly bsModalRef = inject(BsModalRef);

  public buildingChangeLogItems: BuildingChangeLogItemDTO[] = [];
  public building: BuildingDetailsDTO;
  public setOffsetLimit: Subject<{ offset: number; limit: number }> = new Subject();
  public offset: number = 0;
  public limit: number = 10;
  public total: number = 0;

  protected isShowingSystemChanges: boolean = false;
  protected isOther: boolean = false;
  protected buildingSystemChangeLogItems: BuildingSystemChangeLogItemDTO[];

  private selectedParentIndex: number = -1;

  protected onItemClicked(buildingSystemChangeLogItems: BuildingSystemChangeLogItemDTO[], index: number): void {
    this.isOther = true;
    this.isShowingSystemChanges = true;
    this.buildingSystemChangeLogItems = buildingSystemChangeLogItems;
    this.selectedParentIndex = index;
  }

  protected back(isShowing: boolean): void {
    this.isShowingSystemChanges = isShowing;
    this.isOther = false;
  }

  protected setOffset(offset: number): void {
    if (this.offset === offset) {
      return;
    }

    const boxElement: any = document.querySelector('.box');
    boxElement.scrollIntoView({ behavior: 'auto', block: 'start' });

    this.offset = offset;
    this.setOffsetLimit.next({ offset: offset, limit: this.limit });
  }

  protected setLimit(limit: number): void {
    if (this.limit === limit) {
      return;
    }

    const boxElement: any = document.querySelector('.box');
    boxElement.scrollIntoView({ behavior: 'auto', block: 'start' });

    this.limit = limit;
    this.setOffsetLimit.next({ offset: this.offset, limit: limit });
  }

  protected onDone($event: any, isShowing): void {
    if (!isShowing && this.selectedParentIndex !== -1) {
      const element = document.querySelector('.box-' + this.selectedParentIndex);
      element?.scrollIntoView({ behavior: 'auto', block: 'start' });
    } else {
      const boxElement = document.querySelector('.modal-body > cfp-alert') || document.querySelector('.box');
      boxElement?.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  protected close(): void {
    this.bsModalRef.hide();
  }

  protected hasFieldNotApplicable(buildingSystemChangeLogItems: BuildingSystemChangeLogItemDTO[]): boolean {
    return !!buildingSystemChangeLogItems.find(
      (buildingSystemChangeLogItem: BuildingSystemChangeLogItemDTO) =>
        buildingSystemChangeLogItem.newValue?.includes('filter.measureStatus.NON') ||
        buildingSystemChangeLogItem.oldValue?.includes('filter.measureStatus.NON')
    );
  }
}
